import { IUsersTable } from 'types/usersTable';
import api from '../services/config/api';

export const getUsersData = (query?: string) => api.get<IUsersTable>(`/user/filter${query || ''}`);

export const changeUserStatus = (userId: number, newStatus: boolean) =>
  api.patch(`/user/?id=${userId}&status=${newStatus}`);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getClientUsers = (id: string | number) =>
  api.get<{ id: number; name: string; email?: string; enabled?: boolean }[]>(`/user/client`);
// api.get<{ id: number; name: string }[]>(`/user/${id}/client`);
